import React from "react";
import Breakpoint from "util/responsive/breakpoint";
export default function DesktopBreakpoint(props) {
  return <Breakpoint name="desktop">{props.children}</Breakpoint>;
}
